// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-server-result {
  position: absolute;
  top: 12px;
  right: 10px;
  font-size: 28px;
  z-index: 9999;
}

.container-ip-verification-status {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/ip-verification-status/ip-verification-status.component.scss","webpack://./src/components/general%20components/ip-verification-status/ip-verification-status.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;ACCF;;ADEA;EACE,kBAAA;ACCF","sourcesContent":[".test-server-result {\n  position: absolute;\n  top: 12px;\n  right: 10px;\n  font-size: 28px;\n  z-index: 9999;\n}\n\n.container-ip-verification-status{\n  position: relative;\n}",".test-server-result {\n  position: absolute;\n  top: 12px;\n  right: 10px;\n  font-size: 28px;\n  z-index: 9999;\n}\n\n.container-ip-verification-status {\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
